<div class="playerWindow">

 
<div class="stage-main" #stageMain>
   <div class="height-wrapper">
       @if(siteListActive){
    <lib-site-list class="site-list-main" 
      (onSiteListClose)="onSiteListClose($event)"
      (onSelectionUpdate)="onSiteSelectionUpdate($event)"
      [cameraList]="cameraList"
      [searchList$]="searchList$"
      [siteListActive]="siteListActive">
   </lib-site-list>
 }
    <lib-stage
     [selectedCamerasList]="selectedCameras"
     (videoTimeUpdate)="onVideoTimeUpdate($event)"
     class="stageContainer"
     [fullscreenContainer]="stageMain"
     ></lib-stage>

   </div>
   @if(selectedCameras.length){ 
  
         <lib-player class="playerContainer" 
            [selectedCameraList]="selectedCameras"
            [startDate]="startDate"
            [endDate]="endDate"
            [maximumViewPortWidth]="maximumViewPortWidth"
            (timelineChanged)="onTimeLineUpdate($event)"
            [motionOptions]="motionOptions"
            (onDownloadSegment)="onDownloadSegment($event)"
            [videoTime]="videoTime"
            [stage]="stage"
         >
         </lib-player>
   
   }
</div>
  
</div>
